import React from 'react';

const GuidlineStep: React.ElementType = ({ stepNumber }: { stepNumber: number }) => {
    switch (stepNumber) {
        case 1:
            return (
                <>
                    <path
                        d='M116.44 634.99C111.563 631.137 98.3904 625.742 84.7227 634.99'
                        stroke='white'
                        strokeWidth='4'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M80.1273 675.903H49.0991C47.5668 675.903 44.479 672.785 45.4217 668.983C47.0306 662.493 54.3701 649.697 70.8572 650.427C76.6798 650.427 83.2429 653.064 85.7967 654.382'
                        stroke='white'
                        strokeWidth='4'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M82.7222 636.663C82.7222 643.041 77.4442 648.275 70.8552 648.275C64.2662 648.275 58.9883 643.041 58.9883 636.663C58.9883 630.284 64.2662 625.05 70.8552 625.05C77.4442 625.05 82.7222 630.284 82.7222 636.663Z'
                        stroke='white'
                        strokeWidth='4'
                    />
                    <path
                        d='M111.452 617.195C111.452 623.09 106.633 627.895 100.658 627.895C94.6821 627.895 89.8633 623.09 89.8633 617.195C89.8633 611.3 94.6821 606.495 100.658 606.495C106.633 606.495 111.452 611.3 111.452 617.195Z'
                        stroke='white'
                        strokeWidth='4'
                    />
                    <path
                        d='M105.922 655.294L105.918 675.827'
                        stroke='#00E0EA'
                        strokeWidth='4'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M95.3516 665.333L116.497 665.333'
                        stroke='#00E0EA'
                        strokeWidth='4'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </>
            );
        case 2:
            return (
                <>
                    <path
                        d='M409.492 289.725H378.098C375.06 289.725 372.598 292.188 372.598 295.225V313.412C372.598 316.45 375.06 318.912 378.098 318.912H409.492C412.53 318.912 414.992 316.45 414.992 313.412V295.225C414.992 292.188 412.53 289.725 409.492 289.725Z'
                        fill='#00E0EA'
                    />
                    <path
                        d='M409.492 289.725H378.098C375.06 289.725 372.598 292.188 372.598 295.225V313.412C372.598 316.45 375.06 318.912 378.098 318.912H409.492C412.53 318.912 414.992 316.45 414.992 313.412V295.225C414.992 292.188 412.53 289.725 409.492 289.725Z'
                        fill='url(#pattern6)'
                    />
                    <path
                        d='M409.492 289.725H378.098C375.06 289.725 372.598 292.188 372.598 295.225V313.412C372.598 316.45 375.06 318.912 378.098 318.912H409.492C412.53 318.912 414.992 316.45 414.992 313.412V295.225C414.992 292.188 412.53 289.725 409.492 289.725Z'
                        stroke='#00E0EA'
                    />
                    <path
                        d='M382.29 250.967H352.078C349.041 250.967 346.578 253.43 346.578 256.467V274.654C346.578 277.692 349.041 280.154 352.078 280.154H382.29C385.327 280.154 387.79 277.692 387.79 274.654V256.467C387.79 253.43 385.327 250.967 382.29 250.967Z'
                        fill='#290180'
                    />
                    <path
                        d='M382.29 250.967H352.078C349.041 250.967 346.578 253.43 346.578 256.467V274.654C346.578 277.692 349.041 280.154 352.078 280.154H382.29C385.327 280.154 387.79 277.692 387.79 274.654V256.467C387.79 253.43 385.327 250.967 382.29 250.967Z'
                        fill='url(#pattern7)'
                    />
                    <path
                        d='M382.29 250.967H352.078C349.041 250.967 346.578 253.43 346.578 256.467V274.654C346.578 277.692 349.041 280.154 352.078 280.154H382.29C385.327 280.154 387.79 277.692 387.79 274.654V256.467C387.79 253.43 385.327 250.967 382.29 250.967Z'
                        stroke='#00E0EA'
                    />
                    <rect
                        x='321.742'
                        y='289.725'
                        width='41.2116'
                        height='29.1871'
                        rx='5.5'
                        fill='white'
                    />
                    <rect
                        x='321.742'
                        y='289.725'
                        width='41.2116'
                        height='29.1871'
                        rx='5.5'
                        fill='url(#pattern8)'
                    />
                    <rect
                        x='321.742'
                        y='289.725'
                        width='41.2116'
                        height='29.1871'
                        rx='5.5'
                        stroke='#00E0EA'
                    />
                </>
            );
        case 3:
            return (
                <>
                    <g clipPath='url(#clip0_3196_264832)'>
                        <path
                            d='M651.297 534.573H736.695V580.27C736.695 585.792 732.218 590.27 726.695 590.27H661.297C655.774 590.27 651.297 585.792 651.297 580.27V534.573Z'
                            fill='white'
                            stroke='#00E0EA'
                            strokeWidth='2'
                        />
                        <path
                            d='M651.297 533.06C651.297 528.328 655.133 524.492 659.866 524.492H728.126C732.858 524.492 736.695 528.328 736.695 533.06V533.06H651.297V533.06Z'
                            fill='#290180'
                            stroke='#00E0EA'
                            strokeWidth='2'
                        />
                        <path
                            opacity='0.5'
                            d='M673.738 553.373C673.738 549.671 676.74 546.669 680.442 546.669V546.669C684.144 546.669 687.145 549.671 687.145 553.373V571.368H678.738C675.977 571.368 673.738 569.129 673.738 566.368V553.373Z'
                            fill='url(#pattern9)'
                        />
                        <rect
                            opacity='0.5'
                            width='13.4072'
                            height='14.3652'
                            rx='6.70359'
                            transform='matrix(-1 0 0 1 700.555 546.669)'
                            fill='url(#pattern10)'
                        />
                        <rect
                            x='687.148'
                            y='553.978'
                            width='26.8144'
                            height='23.9421'
                            rx='5'
                            fill='url(#pattern11)'
                        />
                        <ellipse
                            cx='658.148'
                            cy='528.902'
                            rx='1.31157'
                            ry='1.1341'
                            fill='white'
                        ></ellipse>
                        <ellipse
                            cx='663.683'
                            cy='528.902'
                            rx='1.31157'
                            ry='1.1341'
                            fill='white'
                        ></ellipse>
                        <ellipse
                            cx='669.222'
                            cy='528.902'
                            rx='1.31157'
                            ry='1.1341'
                            fill='white'
                        ></ellipse>
                        <path
                            d='M756.995 600.941C759.364 601.298 760.84 600.971 761.836 600.941L769.045 594.606C767.191 591.037 762.557 583.853 760.085 584.255C758.437 584.523 759.223 585.15 757.885 584.972C755.207 584.615 756.315 586.724 755.207 586.244C754.099 585.764 752.735 586.422 752.323 587.404C749.13 584.459 748.677 584.401 747.276 583.187C745.114 581.313 742.333 582.741 744.084 584.972L753.699 595.052C752.189 594.576 750.707 594.34 749.786 594.34C747.417 594.34 747.005 596.75 748.344 597.106C753.05 598.361 753.679 600.441 756.995 600.941Z'
                            fill='#00E0EA'
                            stroke='white'
                            strokeLinecap='round'
                        />
                        <path
                            d='M741.819 586.779C737.184 584.281 743.364 576.161 748.925 581.425'
                            stroke='white'
                            strokeWidth='2'
                            strokeLinecap='round'
                        />
                    </g>
                </>
            );
        case 4:
            return (
                <>
                    <path
                        d='M1039.15 164.406C1036.51 174.063 1008.12 176.551 1002.68 164.406V153.431V140.994C1002.68 133.97 1018.86 126.801 1034.01 133.971C1036.47 135.137 1039.15 137.483 1039.15 140.994V154.456V164.406Z'
                        fill='white'
                    />
                    <path
                        d='M1002.68 140.994C1002.68 145.566 1002.68 153.431 1002.68 153.431M1002.68 140.994C1004.44 151.822 1033.57 154.456 1039.15 140.994M1002.68 140.994C1002.68 133.97 1018.86 126.801 1034.01 133.971C1036.47 135.137 1039.15 137.483 1039.15 140.994M1039.15 140.994C1039.15 144.652 1039.15 150.782 1039.15 154.456M1002.68 153.431V164.406C1008.12 176.551 1036.51 174.063 1039.15 164.406C1039.15 163.29 1039.15 159.364 1039.15 154.456M1002.68 153.431C1006.65 159.187 1025.04 166.747 1039.15 154.456'
                        stroke='#290180'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1020.29 131.875H1016.31V135.866C1013.68 137.087 1013.1 139.897 1013.14 141.149H1010.33V144.553H1013.14C1013.33 147.183 1015.33 148.779 1016.31 149.249V152.653H1019.59V149.836H1021.7V152.653H1025.34V149.249C1027.49 148.967 1028.58 147.566 1028.85 146.901C1028.62 146.588 1027.77 145.844 1026.27 145.375C1023.11 147.37 1018.65 146.549 1017.6 144.553C1025.34 144.553 1027.92 142.792 1029.44 141.853C1029.63 138.472 1026.78 135.905 1025.34 135.045V131.875H1021.7V135.045H1020.29V131.875Z'
                        stroke='#00E0EA'
                        strokeWidth='4'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1039.15 155.711C1036.51 165.368 1008.12 167.856 1002.68 155.711V144.737V132.299C1002.68 125.276 1018.86 118.106 1034.01 125.276C1036.47 126.442 1039.15 128.788 1039.15 132.299V145.761V155.711Z'
                        fill='white'
                    />
                    <path
                        d='M1002.68 132.299C1002.68 136.871 1002.68 144.737 1002.68 144.737M1002.68 132.299C1004.44 143.127 1033.57 145.761 1039.15 132.299M1002.68 132.299C1002.68 125.276 1018.86 118.106 1034.01 125.276C1036.47 126.442 1039.15 128.788 1039.15 132.299M1039.15 132.299C1039.15 135.958 1039.15 142.087 1039.15 145.761M1002.68 144.737V155.711C1008.12 167.856 1036.51 165.368 1039.15 155.711C1039.15 154.595 1039.15 150.669 1039.15 145.761M1002.68 144.737C1006.65 150.492 1025.04 158.052 1039.15 145.761'
                        stroke='#290180'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1020.29 178.07C1017.64 187.727 989.258 190.215 983.816 178.07V167.095V154.658C983.816 147.634 999.995 140.464 1015.14 147.634C1017.61 148.8 1020.29 151.146 1020.29 154.658V168.12V178.07Z'
                        fill='white'
                    />
                    <path
                        d='M983.816 154.658C983.816 159.229 983.816 167.095 983.816 167.095M983.816 154.658C985.581 165.486 1014.7 168.12 1020.29 154.658M983.816 154.658C983.816 147.634 999.995 140.464 1015.14 147.634C1017.61 148.8 1020.29 151.146 1020.29 154.658M1020.29 154.658C1020.29 158.316 1020.29 164.445 1020.29 168.12M983.816 167.095V178.07C989.258 190.215 1017.64 187.727 1020.29 178.07C1020.29 176.954 1020.29 173.027 1020.29 168.12M983.816 167.095C987.787 172.85 1006.17 180.411 1020.29 168.12'
                        stroke='#290180'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <mask
                        id='path-35-inside-1_3196_264832'
                        fill='white'
                    >
                        <path d='M981.284 157.114C982.014 159.926 982.033 162.851 981.339 165.67C980.644 168.49 979.254 171.133 977.271 173.403C975.288 175.674 972.763 177.513 969.883 178.785C967.003 180.058 963.843 180.73 960.635 180.753C957.427 180.776 954.255 180.149 951.353 178.919C948.451 177.688 945.894 175.885 943.871 173.644C941.848 171.402 940.411 168.78 939.666 165.97C938.922 163.161 938.888 160.237 939.569 157.414L960.464 161.501L981.284 157.114Z' />
                    </mask>
                    <path
                        d='M981.284 157.114C982.014 159.926 982.033 162.851 981.339 165.67C980.644 168.49 979.254 171.133 977.271 173.403C975.288 175.674 972.763 177.513 969.883 178.785C967.003 180.058 963.843 180.73 960.635 180.753C957.427 180.776 954.255 180.149 951.353 178.919C948.451 177.688 945.894 175.885 943.871 173.644C941.848 171.402 940.411 168.78 939.666 165.97C938.922 163.161 938.888 160.237 939.569 157.414L960.464 161.501L981.284 157.114Z'
                        fill='white'
                        stroke='#290180'
                        strokeWidth='4'
                        mask='url(#path-35-inside-1_3196_264832)'
                    />
                    <path
                        d='M980.846 156.532C980.846 166.517 971.822 174.785 960.464 174.785C949.106 174.785 940.082 166.517 940.082 156.532C940.082 146.547 949.106 138.279 960.464 138.279C971.822 138.279 980.846 146.547 980.846 156.532Z'
                        fill='white'
                        stroke='#290180'
                        strokeWidth='2'
                    />
                    <path
                        d='M960.343 143.49H955.36V148.501C952.078 150.033 951.355 153.561 951.404 155.133H947.887V159.406H951.404C951.638 162.707 954.139 164.712 955.36 165.301V169.575H959.464V166.038H962.101V169.575H966.644V165.301C969.341 164.947 970.699 163.189 971.04 162.354C970.747 161.961 969.692 161.027 967.817 160.438C963.86 162.943 958.291 161.912 956.972 159.406C966.644 159.406 969.868 157.196 971.773 156.017C972.008 151.772 968.452 148.55 966.644 147.469V143.49H962.101V147.469H960.343V143.49Z'
                        stroke='#00E0EA'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </>
            );
        case 5:
            return (
                <>
                    <path
                        d='M1303.43 420.363C1304.11 423.004 1304.13 425.751 1303.48 428.399C1302.83 431.048 1301.53 433.53 1299.68 435.662C1297.83 437.795 1295.47 439.522 1292.78 440.717C1290.08 441.912 1287.13 442.544 1284.13 442.566C1281.14 442.587 1278.17 441.999 1275.46 440.843C1272.75 439.687 1270.36 437.993 1268.47 435.888C1266.58 433.783 1265.24 431.32 1264.54 428.681C1263.85 426.043 1263.82 423.296 1264.45 420.645L1283.97 424.483L1303.43 420.363Z'
                        fill='white'
                        stroke='#290180'
                        strokeWidth='2'
                    />
                    <ellipse
                        cx='1283.97'
                        cy='420.1'
                        rx='19.9786'
                        ry='18.083'
                        fill='white'
                        stroke='#290180'
                        strokeWidth='2'
                    />
                    <path
                        d='M1283.84 408.044H1279.12V412.702C1276.01 414.126 1275.33 417.405 1275.37 418.866H1272.04V422.839H1275.37C1275.59 425.908 1277.96 427.771 1279.12 428.319V432.292H1283V429.004H1285.5V432.292H1289.8V428.319C1292.35 427.99 1293.64 426.355 1293.96 425.579C1293.69 425.214 1292.69 424.346 1290.91 423.798C1287.17 426.127 1281.89 425.168 1280.64 422.839C1289.8 422.839 1292.85 420.784 1294.66 419.688C1294.88 415.743 1291.51 412.747 1289.8 411.743V408.044H1285.5V411.743H1283.84V408.044Z'
                        stroke='#00E0EA'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1309 418.56H1324.75M1309 424.883H1324.75'
                        stroke='#00E0EA'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1354.37 401.1C1354.26 401.109 1353.86 401.143 1353.47 401.171C1350.63 401.375 1347.75 402.162 1345.37 403.386C1340.61 405.839 1337.26 409.847 1335.82 414.837C1335.68 415.316 1335.55 415.785 1335.53 415.88L1335.5 416.06H1333.35H1331.21L1331.04 416.179C1330.75 416.383 1330.75 416.435 1330.76 418.119L1330.78 419.675L1330.99 419.836L1331.2 419.997H1333.02H1334.85L1334.82 420.576C1334.8 420.889 1334.78 421.468 1334.78 421.857V422.559H1333.09C1331.19 422.559 1331.13 422.568 1330.87 422.891L1330.75 423.052L1330.76 424.589L1330.78 426.121L1331.01 426.311L1331.25 426.496H1333.21C1334.74 426.496 1335.18 426.51 1335.19 426.553C1335.21 426.586 1335.28 426.956 1335.37 427.373C1335.99 430.461 1337.37 433.322 1339.29 435.489C1341.48 437.965 1344.24 439.758 1347.51 440.835C1352.07 442.339 1357.44 442.377 1362.17 440.939C1363 440.693 1364.81 439.948 1365.46 439.592C1366.17 439.199 1366.18 439.426 1365.45 437.131C1365.1 436.044 1364.8 435.115 1364.77 435.072C1363.99 435.454 1363.79 435.558 1362.83 435.873C1361.87 436.187 1361.87 436.187 1360.6 436.502C1359.32 436.821 1357.44 436.922 1355.47 437.131C1353.71 437.318 1351.62 437.019 1350.69 436.816C1348.77 436.398 1347.04 435.489 1345.76 434.51C1343.89 433.084 1343.17 432.413 1341.93 430.106C1341.85 429.779 1340.93 428.146 1340.93 426.496H1342.62H1352.21C1362.69 426.496 1361.99 426.515 1362.25 426.23C1362.36 426.107 1362.37 426.055 1362.37 424.532V422.957L1362.15 422.772L1361.92 422.583L1351.98 422.568L1341.21 422.346C1341.21 422.346 1340.89 421.621 1341.21 420.363C1341.29 420.045 1342.12 420.069 1342.14 420.045C1342.16 420.016 1345.84 419.997 1352.07 419.997H1361.97L1362.17 419.808L1362.37 419.618V418.024V416.43L1362.15 416.245L1361.93 416.06H1352.44C1346.44 416.06 1342.95 416.042 1342.95 416.013C1341.21 416.06 1341.82 414.862 1341.93 414.515C1342.57 412.386 1344.1 411.087 1345.37 409.797C1345.83 409.327 1347.47 408.082 1348 407.722C1349.32 406.849 1351.13 406.297 1352.8 406.022C1353.86 405.846 1355.06 405.679 1356.32 405.707C1358.68 405.769 1360.79 406.474 1362.71 407.28C1363.51 407.617 1363.55 407.907 1363.91 407.722C1364.06 407.636 1364.12 407.522 1364.82 405.549C1365.23 404.406 1365.56 403.424 1365.56 403.367C1365.56 403.201 1365.44 403.125 1364.69 402.812C1361.99 401.683 1358.62 401.052 1355.43 401.081C1354.95 401.081 1354.47 401.095 1354.37 401.1Z'
                        fill='white'
                        stroke='#00E0EA'
                    />
                </>
            );
        case 6:
            return (
                <>
                    <path
                        d='M1481.83 49.5125V106.504H1543.98V49.5125H1527.54V28.8798C1527.54 12.2621 1498.6 12.485 1498.6 28.8798V49.5125H1481.83Z'
                        stroke='#00E0EA'
                        strokeWidth='3'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <rect
                        x='1491.29'
                        y='61.5576'
                        width='43.0115'
                        height='34.7968'
                        rx='5'
                        fill='white'
                    />
                    <rect
                        x='1502.55'
                        y='68.4722'
                        width='20.7176'
                        height='21.1904'
                        rx='5'
                        fill='url(#pattern12)'
                    />
                </>
            );
    }
};

export default GuidlineStep;
